import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useOperators } from './operators';

/**
 * Composable that provides pending FAQ filtering context
 * @returns {{ filterTypes: import('vue').ComputedRef }}
 */
export function usePendingFaqFilterContext() {
  const { t } = useI18n();

  const { containmentOperators, dateOperators } = useOperators();

  /**
   * @type {import('vue').ComputedRef}
   */
  const filterTypes = computed(() => [
    {
      attributeKey: 'question',
      value: 'question',
      attributeName: t('PILOT.PENDING_FAQS.FILTER.QUESTION'),
      label: t('PILOT.PENDING_FAQS.FILTER.QUESTION'),
      inputType: 'plainText',
      dataType: 'text',
      filterOperators: containmentOperators.value,
      attributeModel: 'standard',
    },
    {
      attributeKey: 'answer',
      value: 'answer',
      attributeName: t('PILOT.PENDING_FAQS.FILTER.ANSWER'),
      label: t('PILOT.PENDING_FAQS.FILTER.ANSWER'),
      inputType: 'plainText',
      dataType: 'text',
      filterOperators: containmentOperators.value,
      attributeModel: 'standard',
    },
    {
      attributeKey: 'created_at',
      value: 'created_at',
      attributeName: t('PILOT.PENDING_FAQS.FILTER.CREATED_AT'),
      label: t('PILOT.PENDING_FAQS.FILTER.CREATED_AT'),
      inputType: 'date',
      dataType: 'text',
      filterOperators: dateOperators.value,
      attributeModel: 'standard',
    },
    {
      attributeKey: 'updated_at',
      value: 'updated_at',
      attributeName: t('PILOT.PENDING_FAQS.FILTER.UPDATED_AT'),
      label: t('PILOT.PENDING_FAQS.FILTER.UPDATED_AT'),
      inputType: 'date',
      dataType: 'text',
      filterOperators: dateOperators.value,
      attributeModel: 'standard',
    },
  ]);

  return { filterTypes };
}
